export enum OrderStatus {
    Ordered = 0,
    Paid = 1,
    PaymentFailedOrCancelled = 2,
    InvoiceGenerated = 3
}
